export default "__VITE_ASSET__a8475846__"